import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { DatatableComponent } from './../../shared/components/data-table/datatable.component';
import { ICAService } from '../../services/http/ica.service';
import { ModalService } from '../../shared/services/modal.service';
import { Sit2Service } from '../../services/http/sit2.service';
import { LoginService } from '../../services/http/login.service';
import { securityContext } from '../../utils/Security';

declare let gtag: Function;

@Component({
  selector: 'app-firmar-electronicamente-pendientes-ica',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './firmar_electronicamente_pendientes_ica.component.html',
  styleUrl: './firmar_electronicamente_pendientes_ica.component.scss'
})

export class FirmarElectronicamentePendientesICAComponent extends DatatableComponent implements OnInit {

  showViewHTMLComponent = false;
  listActividades = [];
  abrirModalEliminar = false;
  abrirModalFirma = false;
  elementoAFirmar: any = null;
  elementoAEliminar: any = null;
  urlAuti = "";
  urlRecuperarClave = "";
  passwordVisible = false;

  tiposId: any[] = [];
  roles: any[] = [];

  miRol = 1;
  usuario = {
    tipoId: "CC",
    nroId: "",
    clave: "",
    autenticado: "0",
    rol: "" + this.miRol
  }

  activar = false;

  miEstado: any = null;
  miTipoRevisor: any = null;

  usuarioRol = new FormControl('', Validators.required);
  usuarioTipoId = new FormControl('', Validators.required);
  usuarioNroId = new FormControl('', [Validators.required, Validators.minLength(3)]);
  usuarioPassword = new FormControl('', [Validators.required, Validators.minLength(3)]);

  override originalData: any[] = [];

  constructor(private router: Router,
    private icaService: ICAService,
    private sit2Service: Sit2Service,
    private modalService: ModalService,
    private authService: AuthService,
    private loginService: LoginService) {
    super()
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {

    }
    const config = this.authService.getValueConfig();
  }

  cambiaRol() {
    const soporte = this.elementoAFirmar;
    this.usuario.rol = String(this.usuarioRol.value);
    if (parseInt(this.usuario.rol, 10) == 3) {
      this.usuario.nroId = soporte.nroIdRl;
      this.usuario.tipoId = soporte.tipoIdRl;
    } else {
      this.usuario.nroId = soporte.nroIdRf;
      this.usuario.tipoId = soporte.tipoIdRf;
    }
    
    this.usuarioTipoId.enable();
    this.usuarioTipoId.setValue(this.usuario.tipoId);
    this.usuarioTipoId.disable();
    this.usuarioNroId.enable();
    this.usuarioNroId.setValue(this.usuario.nroId);
    this.usuarioNroId.disable();
    this.usuarioPassword.setValue("");
  };

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }
    this.getPendientes();

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/por_firmar_ica/firma_electronica' });
      } catch (err) { }
    }
  }

  getPendientes() {
    this.icaService.getPendientesPorFirmar().subscribe({
      next: (response) => {
        const originalData = this.verificaArray(response.lista);
        for (let x = 0; x < originalData.length; x++) {
          originalData[x].$$key_data_id = x;
          originalData[x].$$isMenuOpen = false;
        }
        this.originalData = originalData;
        this.applyFilter();
        this.showViewHTMLComponent = true;
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }

  override applyFilter(): void {
    const searchTerm = this.filterTerm.toLowerCase();
    this.currentData = this.originalData.filter(item =>
      String(item.vigencia).toLowerCase().includes(searchTerm) ||
      String(item.nombrePeriodo).toLowerCase().includes(searchTerm) ||
      String(item.nroReferencia).toLowerCase().includes(searchTerm) ||
      String(item.fechaCreacion).toLowerCase().includes(searchTerm) ||
      String(item.fechaPago).toLowerCase().includes(searchTerm) ||
      String(item.descEstado).toLowerCase().includes(searchTerm) ||
      String(item.valorPagar).toLowerCase().includes(searchTerm)
    );

    this.currentPage = 1;
  }

  getFormulario(obj: any) {
    this.toggleMenuAll();
    const idSoporte = obj.idSoporte;
    const config = this.authService.getValueConfig();
    this.sit2Service.cifrarIdXBarcode(idSoporte).subscribe({
      next: (response) => {
        if (!(response === void 0)) {
          window.open(config.urlFormulario + response.valor);
        } else {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Servicio no disponible, por favor intente más tarde");
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: any): void {
    // Si el clic no fue dentro de un dropdown, cierra todos los menús
    const clickedInsideDropdown = targetElement.closest('.dropdown');
    if (!clickedInsideDropdown) {
      if (this.controlCloseAllMenus) {
        let temp = [...this.currentData].map((item_local) => {
          return {
            ...item_local,
            $$isMenuOpen: false
          };
        });
        this.currentData = temp;
        this.controlCloseAllMenus = false;
      }
    }
  }

  isValidFormFirmar() {
    return this.usuarioPassword.valid;
  }

  cerrarDialogoFinalizacionFirma() {
    this.abrirModalFirma = false;
    this.elementoAFirmar = null;
  }

  elementoAFirmarParaModal(item: any) {

    this.elementoAFirmar = item;
    this.abrirModalFirma = true;

    this.tiposId = [{ cod: "CC", desc: "Cedula de Ciudadania" }, { cod: "CE", desc: "Cedula de Extranjeria" }, { cod: "NIT", desc: "N.I.T." }, { cod: "PA", desc: "Pasaporte" }, { cod: "TI", desc: "Tarjeta de Identidad" }];
    const config = this.authService.getValueConfig();
    this.urlAuti = config.urlAuti;
    this.urlRecuperarClave = config.urlRecuperarClave;

    const soporte = this.elementoAFirmar;

    this.miEstado = parseInt(soporte.estado, 10);
    this.miRol = 1;
    this.miTipoRevisor = parseInt(soporte.tipoRevisor, 10);

    switch (this.miEstado) {
      case 0: if (this.miTipoRevisor == 1) {
        this.miRol = 1;
      } else {
        this.miRol = 2;
      }
        break;
      case 1:
      case 2: this.miRol = this.miTipoRevisor; break;
      case 3: this.miRol = 3; break;
      default: this.miRol = this.miTipoRevisor;
    }

    this.activar = this.miEstado != 0;

    this.usuario = {
      tipoId: "CC",
      nroId: "",
      clave: "",
      autenticado: "0",
      rol: "" + this.miRol
    }

    if (this.miTipoRevisor == 1) {
      this.roles = [{ "codigo": "1", "nombre": "Contador" }, { "codigo": "3", "nombre": "Representante legal" }];
    } else {
      this.roles = [{ "codigo": "2", "nombre": "Revisor Fiscal" }, { "codigo": "3", "nombre": "Representante legal" }];
    }

    this.usuarioRol.setValue(this.usuario.rol);
    this.cambiaRol();

    if (this.activar) {
      this.usuarioRol.disable();
    } else {
      this.usuarioRol.enable();
    }
    this.usuarioTipoId.enable();
    this.usuarioTipoId.setValue(this.usuario.tipoId);
    this.usuarioTipoId.disable();
    this.usuarioNroId.enable();
    this.usuarioNroId.setValue(this.usuario.nroId);
    this.usuarioNroId.disable();
    this.usuarioPassword.setValue("");
  }

  verifyUser() {
    const validRoles = this.roles.filter(item => String(item.codigo) == String(this.usuarioRol.value));
    if (validRoles.length != 1) {
      this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Por favor diligencie correctamente el nombre del usuario y la clave para poder acceder al sistema");
      return;
    }

    if (this.usuarioPassword.valid) {
      const usuario = {
        tipoId: this.usuario.tipoId,
        nroId: this.usuario.nroId,
        clave: this.usuario.clave,
        autenticado: this.usuario.autenticado,
        rol: this.usuarioRol.value,
        password: this.usuarioPassword.value
      }
      let texto = JSON.stringify(usuario);
      texto = securityContext().encrypt(texto);
      this.loginService.autenticarseParaFirmar(texto).subscribe({
        next: (response) => {
          if (response.status == "0") {
            this.elementoAFirmar.roleFirmante = usuario.rol;
            this.registrarFirma();
          } else {
            let mensaje = String(response.msg);
            mensaje = mensaje.replaceAll("\\xa1", "á");

            if ("Usuario o clave no válidos" == mensaje) {
              this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.WARING, "Credenciales inválidas", mensaje);
            } else {
              this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.WARING, "", mensaje);
            }
          }
        },
        error: (err) => {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
        }
      });
    } else {
      this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Por favor diligencie correctamente el nombre del usuario y la clave para poder acceder al sistema");
    }
  }

  registrarFirma() {
    let data: any = { ...this.elementoAFirmar };
    delete data.$$key_data_id;
    delete data.$$isMenuOpen;
    this.loginService.registrarFirma(data).subscribe({
      next: (response) => {
        if (response.mensaje == "OK") {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.SUCCESS, "Firma electrónica exitosa", `La declaración tributaria ha sido presentada.\nObtenga la certificación por la opción consultar pagos.`);
          this.getPendientes();
          this.cerrarDialogoFinalizacionFirma();
          if (typeof gtag === 'function') {
            try {
              gtag('event', 'sign_tax_form', {
                'event_category': 'Declaration',
                'event_label': 'ICA'
              });
            } catch (err) { }
          }
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Hubo un error durante el proceso de registro de la  firma electrónica, por favor intente más tarde");
      }
    });
  }

  cerrarDialogoFinalizacionEliminar() {
    this.abrirModalEliminar = false;
    this.elementoAEliminar = null;
  }

  elementoAEliminarParaConfirmar(item: any) {
    this.abrirModalEliminar = true;
    this.elementoAEliminar = item;
  }

  eliminarFilaFormulario() {
    this.toggleMenuAll();
    this.abrirModalEliminar = false;
    if (this.elementoAEliminar !== null) {
      let data: any = { ...this.elementoAEliminar };
      delete data.$$key_data_id;
      delete data.$$isMenuOpen;
      this.icaService.discardForm(data).subscribe({
        next: (response) => {
          if (response.mensaje == "OK") {
            this.removerElementoDeTabla();
            this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.SUCCESS, "", "Se ha anulado el formulario");
          } else {
            this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "No se pudo anular el formulario, " + response.mensaje);
          }
        },
        error: (err) => {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor, por favor intente más tarde");
        }
      });
    }
  }

  removerElementoDeTabla() {
    if (this.elementoAEliminar !== null) {
      const temp = [...this.currentData].filter(objeto => objeto.$$key_data_id != this.elementoAEliminar.$$key_data_id).map(objeto => ({ ...objeto }));
      const tempOrigin = [...this.originalData].filter(objeto => objeto.$$key_data_id != this.elementoAEliminar.$$key_data_id).map(objeto => ({ ...objeto }));
      this.currentData = temp;
      this.originalData = tempOrigin;

      if (this.paginatedData.length == 0) {
        if (this.currentPage - 1 > 0) {
          this.currentPage--;
        } else {
          this.currentPage = 1;
        }
      }
      this.elementoAEliminar = null;
    }
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
}
